import axios from 'axios'
import { i18nRequestInterceptor } from './i18n'
axios.defaults.withCredentials = true
import { traceRequestInterceptor, traceResponseInterceptor } from './trace'


export const getHttpService = function () {
  if ( window.$httpUtil && window.$httpUtil.instance) {
    return window.$httpUtil.instance
  }

  const httpService = axios.create({
    baseURL: window.$ZConfig.getServerUrl(), // 设置统一的请求前缀
    withCredentials: true, // 跨域请求时发送cookies
  });
  

  /* eslint-disable no-proto */
  httpService.__proto__ = axios
  /* eslint-enable */

  httpService.interceptors.request.use(traceRequestInterceptor)
  httpService.interceptors.request.use(i18nRequestInterceptor)
  httpService.interceptors.response.use(traceResponseInterceptor)
  //添加一个请求拦截器
  httpService.interceptors.request.use(
    (config) => {
      // removePending(config);
      // addPending(config);
      return Promise.resolve(config);
    }, (error) => {
      return Promise.reject(error);
    }
  )

  //添加一个响应拦截器
  httpService.interceptors.response.use(
    res => {
      let data = res.data || {}
      if (data.code == '-90') {
        window.location.replace('/v/powerTip.html')
        return 
        // return Promise.reject(new Error('无权限'))
      }
      if (data.code == '-99' && res.request.responseURL.indexOf('/api/pp/common/platform/home/initData.json') == -1 && res.request.responseURL.indexOf('isLogin.json') == -1) {
        if (res.request.responseURL.indexOf('cs/getUserAndStandardInfo.json') !== -1) {
          // 因为云客服嵌套跳转登陆不能采用$jump.toLogin()，而是要在嵌套处跳转
          window.open($ZConfig.getUrl('DOMAIN_ADMIN') + '/login')
        } else {
          //sessionStorage.removeItem('_logined');
          //window.location.reload();
          $jump.toLogin()
          return Promise.reject(new Error('请先登录'))
        }
      } else {
        return Promise.resolve(res)
      }
    },
    error => {
      // error.config && removePending(error.config);
      return Promise.reject(error);
    }
  )

  const httpUtil = {
    instance: httpService
  }
  window.$httpUtil = httpUtil
  return httpUtil
}

